import React from "react";
import Layout from "@hoc/layouts/Layout";
import SuccessForm from "@components/Success/SuccessForm";

const SuccessPage = () => {
  return (
    <Layout>
      <SuccessForm/>
    </Layout>
  );
}

export default SuccessPage;
